<template>
    <div class="info-img">
        <h3 class="cont-tit">이미지정보</h3>
        <div class="img-box">
            <div class="gallery-img">
                <img :src="firstImageUrl" alt="">
            </div>
            <div class="thmub-imgs">
                <div class="swiper-container swiper-container-horizontal">
                    <div class="swiper-wrapper">
                        <div v-for="n in imageData.pages" :key="n"
                            class="swiper-slide" :id="'image_slide'+(n-1)">
                            <div class="img-wrap" v-for="m in imageData.pagePerImage" :key="n+'-'+m">
                                <img :src="imageData.images[(n-1)*imageData.pagePerImage+(m-1)].originimgurl" alt=""
                                    v-if="isNotEmpty(imageData.images[(n-1)*imageData.pagePerImage+(m-1)])">
                            </div>
                        </div>
                    </div>
                    <span class="swiper-notification" aria-live="assertive" aria-atomic="true"></span></div>
                <div class="pagination-wrap">
                    <div class="swiper-pagination swiper-pagination-fraction">
                        <span class="swiper-pagination-current">1</span> / <span class="swiper-pagination-total">2</span>
                    </div>
                    <div class="btn-wrap">
                        <button type="button" class="btn-prev swiper-button-disabled" tabindex="0" role="button" aria-label="Previous slide" aria-disabled="true">이전</button>
                        <button type="button" class="btn-next" tabindex="0" role="button" aria-label="Next slide" aria-disabled="false">다음</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        firstImageUrl: { type: String, default: " " }, // 첫번째 이미지 주소
        imageData: { type: Object }
    },
    mounted(){
        setTimeout(t=>{
            this.initSlide();
        },50);
    },
    methods: {
        initSlide() {
            var relativeOrgan = new Swiper('.local-festival .detail .img-box .swiper-container', {
                slidesPerView: 2,
                navigation: {
                    nextEl: '.local-festival .detail .img-box .btn-next',
                    prevEl: '.local-festival .detail .img-box .btn-prev',
                },
                pagination: {
                    el: '.local-festival .detail .img-box .swiper-pagination',
                    type: 'fraction',
                },
                breakpoints: {
                    768: {
                        slidesPerView: 1,
                    },
                }
            });

            $('.local-festival .detail .img-box .thmub-imgs .img-wrap').on('click', function () {
                var clickImg = $(this).find('img').attr('src');
                $('.local-festival .detail .img-box .gallery-img img').attr('src', clickImg);
            });
        },
    }
}
</script>